var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterIconSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    rx: 1,
    fill: "#B7B7B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00732 6.12478L3.00737 6.12482L5.00655 8.00552C5.00666 8.00562 5.00677 8.00573 5.00689 8.00584C5.21112 8.19983 5.53849 8.19601 5.74182 8.00661C5.95271 7.81019 5.95183 7.48617 5.74241 7.289L4.65849 6.26853H9.62513C10.4586 6.26853 11.15 5.63023 11.15 4.82413V2.35302C11.15 2.06615 10.907 1.85 10.625 1.85C10.3431 1.85 10.1001 2.06615 10.1001 2.35302V4.82266C10.1001 5.0565 9.89622 5.26102 9.62513 5.26102H4.65849L5.74182 4.2411C5.74194 4.24099 5.74206 4.24088 5.74218 4.24077C5.95349 4.04357 5.94917 3.72024 5.74299 3.52404C5.53946 3.33037 5.21144 3.33114 5.00713 3.52349L5.00709 3.52353L3.00791 5.40717C3.00779 5.40728 3.00767 5.40739 3.00755 5.40751C2.79703 5.60397 2.79802 5.92772 3.00732 6.12478Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIconSolid);
export default __webpack_public_path__ + "static/media/enterIconSolid.2eaa7a4dde95d6c206701e629ee70461.svg";
export { ForwardRef as ReactComponent };